export enum GradeSelectorFilterId {
    Engine = "engine",
    WheelDrive = "wheelDrive",
    Transmission = "transmission",
    Colour = "colour",
}
